import { CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Checkbox } from 'components/tailwind-ui/Checkbox';
import { StatusPill } from 'pages/Shipments/components/StatusPill';
import { PresetView } from 'pages/Shipments/Containers/types';
import { useWatchlistFilters } from 'pages/Shipments/Containers/utilities';
import * as React from 'react';
import { WatchlistQueryKeys, getShippersListCount } from 'services/clients/watchList';
import { CurrentContainerStatus } from 'types/Watchlist';

interface Props {
  status: CurrentContainerStatus;
  checked: boolean;
  onChange: (status: CurrentContainerStatus, checked: boolean) => void;
  presetView: PresetView;
}

export const StatusEntry: React.FC<Props> = (props) => {
  const { status, checked, onChange, presetView } = props;

  const filters = useWatchlistFilters(presetView);

  const isExcludedStatus =
    filters.containerStatus &&
    filters.containerStatus.length > 0 &&
    !filters.containerStatus?.includes(status);

  const countQuery = useQuery({
    queryKey: [WatchlistQueryKeys.ShippersListCount, { ...filters, containerStatus: [status] }],
    queryFn: ({ signal }) =>
      getShippersListCount({ filters: { ...filters, containerStatus: [status] }, signal }),
  });

  return (
    <Checkbox
      onCheck={(c) => onChange(status, c)}
      checked={checked}
      className="px-3 py-2 hover:bg-blue-200 cursor-pointer!"
      id={`status-filter-${status}`}
      label={
        <div className="flex space-x-2 items-center">
          <StatusPill status={status} />
          {countQuery.isLoading ? (
            <CircularProgress size={14} />
          ) : (
            <h4 className={`${isExcludedStatus ? 'text-gray-300' : 'text-gray-800'}`}>
              {countQuery.data?.count}
            </h4>
          )}
        </div>
      }
    />
  );
};
